import styled from "styled-components";

export const ProjectTransferContainer = styled.div`
  width: 220px;
`;

export const ProjectTransferHeader = styled.div`
  border: unset;
  width: 220px;
  height: 26px;
  background: #27282c;
  color: rgba(140, 146, 148, 0.85);
  line-height: 26px;
  text-align: center;
`;

export const ProjectTransferBody = styled.div`
  position: relative;
  border-radius: 3px;
  height: 367px;
  overflow: auto;
  background-color: rgb(44, 44, 49);
  padding-top: 4px;
  .ant-empty-normal {
    height: calc(330px - 42px - 32px);
    display: flex;
    flex-direction: column;
    justify-content: center;
    .ant-empty-description {
      color: #fff;
    }
  }
  .search-input {
    width: calc(100% - 16px);
    margin: 0 8px;
    background: #222227 !important;
    border-radius: 4px;
    height: 30px;
    padding: 0 8px;
    input {
      background: #222227 !important;
      padding: 0;
      margin: 0 !important;
    }
    svg[data-icon="search"] {
      fill: #728389;
    }
    svg[data-icon="close-circle"] {
      fill: #728389;
    }
  }
`;

export const NotFoundWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  color: rgba(140, 146, 148, 0.85);
  span {
    width: max-content;
  }
`;

export const ProjectTransferAction = styled.div`
  background-color: var(--main-color);
  border-radius: 4px;
  border-color: var(--main-color);
  width: 24px;
  height: 24px;
  margin: auto 30px;
  .anticon {
    display: flex;
    align-items: center;
    justify-content: space-around;
    height: 100%;
  }
`;

export const ProjectTransferWrapper = styled.div`
  display: flex;
`;
export const ProjectTransferItem = styled.div`
  display: flex;
  align-items: center;
  padding: 5px 12px;
  transition: all 0.3s;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  flex: auto;
  cursor: pointer;
`;

export const ProjectTransferRightItem = styled(ProjectTransferItem)`
  cursor: initial;
  justify-content: space-between;
  .anticon {
    cursor: pointer;
    &:hover {
      color: rgb(245, 83, 60);
    }
  }
`;
